import { gql } from "@apollo/client";

export const DELETE_CUSTOM_QUERY_PACK = gql`
  mutation DeleteCustomQueryPack($input: DeleteCustomQueryPackInput!) {
    deleteCustomQueryPack(input: $input) {
      queryPackMrn
    }
  }
`;
